<template>
	<img
		class="profile-img"
		@error.once="error"
		:style="style"
		:src="src || defaultImg"
	/>
</template>

<script>
	const defaultImg = '/static/img-profile-default.png';

	export default {
		name: 'ProfileImg',
		props: {
			size: {
				type: Number,
				default: 40,
			},
			src: {
				type: String,
				default: defaultImg,
			},
		},
		data() {
			return {
				defaultImg,
			};
		},
		computed: {
			style() {
				const size = this.size;
				return {
					width: `${size}px`,
					height: `${size}px`,
				};
			},
		},
		methods: {
			error(e) {
				e.target.src = this.defaultImg;
			},
		},
	};
</script>

<style lang="scss" scoped>
	IMG.profile-img {
		display: inline-block;
		outline: none;
		border: none;
		border-radius: 50%;
	}
</style>
